// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"a681601a","300":"0278ab83","625":"0278ab83","635":"81e2dfae","691":"0a86ff52","724":"0a86ff52","904":"0278ab83","976":"0278ab83"}[chunkId] + ".chunk.css";
};